import { memo, useId } from 'react'

import { landscape, starField } from '@/lib/brand/landscape'

const STARS = starField()
const LAND = landscape()

/**
 * The land behind the dashboard: night sky, stars and the badlands with a few
 * fires out on the plain (day in light mode). Static SVG and gradients, drawn
 * once: it costs nothing per frame, so it never competes with the app.
 */
export const CampBackdrop = memo(function CampBackdrop({ className }: { className?: string }) {
  const glow = `bl-fire-${useId().replace(/[^a-zA-Z0-9]/g, '')}`
  return (
    <div aria-hidden="true" className={`bl-backdrop ${className ?? ''}`}>
      <svg className="bl-stars" viewBox="0 0 1000 600" preserveAspectRatio="xMidYMin slice">
        {STARS.map((star, index) => (
          <circle key={index} cx={star.x} cy={star.y} r={star.r} opacity={star.o} style={{ fill: 'var(--bl-star)' }} />
        ))}
        {STARS.filter(star => star.glint).map((star, index) => (
          <path
            key={`g${index}`}
            d={`M${star.x - 4} ${star.y}H${star.x + 4}M${star.x} ${star.y - 4}V${star.y + 4}`}
            strokeWidth={0.35}
            opacity={star.o * 0.7}
            style={{ stroke: 'var(--bl-star)' }}
          />
        ))}
      </svg>
      <svg data-land viewBox={`0 0 ${LAND.width} ${LAND.height}`} preserveAspectRatio="xMidYMax slice" className="h-[min(34vh,calc(var(--spacing)*88))]">
        <defs>
          <radialGradient id={glow}>
            <stop offset="0" style={{ stopColor: 'var(--bl-fire)', stopOpacity: 0.85 }} />
            <stop offset="1" style={{ stopColor: 'var(--bl-fire)', stopOpacity: 0 }} />
          </radialGradient>
        </defs>
        <path d={LAND.ridges.far} style={{ fill: 'var(--bl-ridge-far)' }} />
        {LAND.fires.map((fire, index) => (
          <g key={index} style={{ opacity: 'var(--bl-star-opacity)' }}>
            <circle cx={fire.x} cy={fire.y} r={fire.r * 3.2} fill={`url(#${glow})`} />
            <circle cx={fire.x} cy={fire.y} r={fire.r * 0.42} style={{ fill: 'var(--bl-fire)' }} />
          </g>
        ))}
        <path d={LAND.ridges.mid} style={{ fill: 'var(--bl-ridge-mid)' }} />
        <path d={LAND.ridges.near} style={{ fill: 'var(--bl-ridge-near)' }} />
      </svg>
    </div>
  )
})
